import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { TweenMax } from "gsap";
import Draggable from "gsap/Draggable";
import ScrollToPlugin from "gsap/ScrollToPlugin";

import {
  layout,
} from '../../theme';

// Import from Style
import {
  HeadingTwo,
  Text,
  Inset
} from '../../elements';

// Import from Style
import {
  Wrapper,
  SliderPadding,
  SliderWrapper,
  Slider,
  SliderItem,
  ZoomedItems,
  ZoomCloseButton,
} from './style';

import ScrollingListItem from '../ScrollingListItem';
import Tooltip from '../Tooltip';
import AppState from '../../states/AppState';
import ListsState from '../../states/ListsState';

class ScrollingList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dragging: false,
      hovered: false,
      fadeSecondaryItems: true,
      offset: 0,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.initDraggable);
    this.initDraggable();
  }

  componentDidUpdate(oldProps) {
    if (this.props.children !== oldProps.children) this.initDraggable();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.initDraggable);
    clearTimeout(this.initTimeout);
  }

  initDraggable = () => {
    if (this.containerEl && this.draggableEl) {
      this.resetDraggable();
    } else {
      this.initTimeout = setTimeout(this.initDraggable, 100);
    }
  }

  handleDragComplete = (x) => {
    this.setState({ offset: x });
  }

  resetDraggable = () => {
    const containerRect = this.containerEl.getBoundingClientRect();
    const draggableRect = this.draggableEl.getBoundingClientRect();
    const _this = this;

    this.draggable = Draggable.create(this.draggableEl, {
      bounds: {
        maxX: 0,
        minX: (draggableRect.width - containerRect.width) * -1
      },
      cursor: 'grab',
      dragClickables: true,
      edgeResistance: 0.65,
      maxDuration: 1.5,
      minimumMovement: 6,
      overshootTolerance: 0.4,
      throwProps: true,
      throwResistance: 100,
      type: 'x',
      zIndexBoost: false,
      onPress: () => {
        AppState.showScrollingListHelper = false;
        this.setState({ dragging: true, fadeSecondaryItems: false });
      },
      onRelease: () => {
        this.setState({ dragging: false });
      },
      onThrowUpdate: function() {
        _this.handleDragComplete(this.x);
      },
      onThrowComplete: function() {
        _this.handleDragComplete(this.x);
      },
    });

    this.draggable.maxX = 0;
  }

  render() {
    const { dragging, hovered, fadeSecondaryItems, offset } = this.state;
    const { list, listIndex } = this.props;

    return (
      <Wrapper>
        {AppState.showScrollingListHelper && hovered && <Tooltip text="Drag" />}
        <Inset>
          <HeadingTwo>{list.heading}</HeadingTwo>
          <Text
            dangerouslySetInnerHTML={{
              __html: list.intro
            }}
          />
        </Inset>
        <SliderPadding>
          <SliderWrapper
            innerRef={(el) => this.containerEl = el}
            onMouseMove={() => this.setState({ hovered: true })}
            onMouseLeave={() => this.setState({ hovered: false })}
            style={{
              height: AppState.boxSize
            }}
          >
            <Slider
              className={dragging ? 'dragging' : ''}
              innerRef={(el) => this.draggableEl = el}
            >
              {list.items.map((item, itemIndex) => (
                <SliderItem key={itemIndex}>
                  <ScrollingListItem
                    faded={!hovered && itemIndex > 0 && fadeSecondaryItems}
                    listIndex={listIndex}
                    offset={offset}
                    itemIndex={itemIndex}
                    item={item}
                  />
                </SliderItem>
              ))}
            </Slider>
          </SliderWrapper>
        </SliderPadding>
        {AppState.regularMode && (
        <ZoomedItems>
          {list.items.map((item, itemIndex) => (
            <ScrollingListItem
              key={itemIndex}
              listIndex={listIndex}
              itemIndex={itemIndex}
              item={item}
              popUp
            />
          ))}
        </ZoomedItems>
        )}
        {AppState.regularMode && ListsState.activeItem && (
          <ZoomCloseButton
            onClick={(evt) => {
              evt.preventDefault();
              ListsState.toggleZoom(listIndex, null);
            }}
          />
         )}
      </Wrapper>
    );
  }
}

export default observer(ScrollingList);



// WEBPACK FOOTER //
// ./src/components/ScrollingList/index.js